(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["foundation-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.foundation-video-wrapper').forEach(function (wrapper) {
    var video = wrapper.querySelector('video');
    if (!video) return;

    var playPauseBtn = wrapper.querySelector('.js-play-pause');
    var muteBtn = wrapper.querySelector('.js-mute-toggle');
    var iconPlay = playPauseBtn.querySelector('.icon-play');
    var iconPause = playPauseBtn.querySelector('.icon-pause');
    var iconMuted = muteBtn.querySelector('.icon-muted');
    var iconUnmuted = muteBtn.querySelector('.icon-unmuted');

    function syncPlayIcon() {
      if (video.paused) {
        iconPlay.style.display = '';
        iconPause.style.display = 'none';
      } else {
        iconPlay.style.display = 'none';
        iconPause.style.display = '';
      }
    }

    function syncMuteIcon() {
      if (video.muted) {
        iconMuted.style.display = '';
        iconUnmuted.style.display = 'none';
      } else {
        iconMuted.style.display = 'none';
        iconUnmuted.style.display = '';
      }
    }

    function togglePlayPause() {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }

    wrapper.addEventListener('click', function (e) {
      if (e.target.closest('.video-control-btn')) return;
      togglePlayPause();
    });

    playPauseBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      togglePlayPause();
    });

    muteBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      syncMuteIcon();
    });

    video.addEventListener('play', syncPlayIcon);
    video.addEventListener('pause', syncPlayIcon);

    syncPlayIcon();
    syncMuteIcon();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sugar-free-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sugar-free-video-wrapper').forEach(function (wrapper) {
    var video = wrapper.querySelector('video');
    if (!video) return;

    var playPauseBtn = wrapper.querySelector('.js-play-pause');
    var muteBtn = wrapper.querySelector('.js-mute-toggle');
    var iconPlay = playPauseBtn.querySelector('.icon-play');
    var iconPause = playPauseBtn.querySelector('.icon-pause');
    var iconMuted = muteBtn.querySelector('.icon-muted');
    var iconUnmuted = muteBtn.querySelector('.icon-unmuted');

    function syncPlayIcon() {
      if (video.paused) {
        iconPlay.style.display = '';
        iconPause.style.display = 'none';
      } else {
        iconPlay.style.display = 'none';
        iconPause.style.display = '';
      }
    }

    function syncMuteIcon() {
      if (video.muted) {
        iconMuted.style.display = '';
        iconUnmuted.style.display = 'none';
      } else {
        iconMuted.style.display = 'none';
        iconUnmuted.style.display = '';
      }
    }

    function togglePlayPause() {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }

    wrapper.addEventListener('click', function (e) {
      if (e.target.closest('.video-control-btn')) return;
      togglePlayPause();
    });

    playPauseBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      togglePlayPause();
    });

    muteBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      syncMuteIcon();
    });

    video.addEventListener('play', syncPlayIcon);
    video.addEventListener('pause', syncPlayIcon);

    syncPlayIcon();
    syncMuteIcon();
  });
});

  } catch(e) { console.error(e); }
})();
})();
